module.exports = __webpack_public_path__ + "static/img/powerguarantee.ee3ec0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/powerguarantee.png
// module id = uN/T
// module chunks = 1